<template>
  <div class="site-wrapper">
    <slot name="sidebar" />
    <slot name="header" />
    <main class="site-main">
      <div class="site-content">
        <slot name="default" />
      </div>
    </main>
  </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';

import { mapGetters, mapActions } from 'vuex';

@Component({
  name: 'main-layout',
  computed: mapGetters(['user']),
  methods: mapActions(['userLogout']),
})
export default class MainLayout extends Vue {}
</script>
<style lang="scss">
.site-wrapper {
  height: 100vh; /* Use vh as a fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
  min-height: 480px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.site-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.site-content {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
</style>
